module.exports = __webpack_public_path__ + "img/syukyaku-top-Z02.40d58b35.png";